export default {
    APIUSR: "LadeconfigAPIUser",
    APIPASWD: "TMxHLyx4FE7iN1eJQ1GTVgIQl6PSEBvHI1TRw7HD",
    LADECAT: 641,
    SWURL: "https://www.duovorm.nl",
}
// #StagingL
// #SW_URL=https://duovorm.kienerbouwt.nl
// #SW_API_USR=LadeconfigAPIUser
// #SW_API_PASWD=8LyDJx6o1kB1Jio3DTByMEGcAD5fHqOL7EP3UE4e
// #SW_APP_CATID=583
//
// LIVE
// SW_URL=https://www.duovorm.nl
// SW_API_USR=LadeconfigAPIUser
// SW_API_PASWD=TMxHLyx4FE7iN1eJQ1GTVgIQl6PSEBvHI1TRw7HD
// SW_APP_CATID=641
